import type { NextPage } from "next";
import Image from "next/image";

import BackgroundImage from "public/images/enerflo-background-solarfarm.png";

import Page from "../../components/layout/page";
import Content from "../../components/views/contact/content";
import MainHero from "../../components/views/contact/main-hero";

const ContactUs: NextPage = () => (
  <Page
    title="Enerflo Solar Software Platform | Contact Us"
    description="Don’t be shy. We want to hear from you! Interested in seeing a demo? Have a question? Want to share deep thoughts on solar? We’re up for all of it."
  >
    <div className="relative bg-gradient-to-b from-white to-transparent pt-4 pb-44 md:pt-10">
      <figure className="absolute h-full w-full z-[-1] inset-0">
        <Image
          src={BackgroundImage}
          alt="solar sky background"
          layout="fill"
          className="object-center object-cover"
          priority
          loading="eager"
        />
      </figure>
      <MainHero />
      <Content />
    </div>
  </Page>
);

export default ContactUs;
